import CaseStudy from 'pages/CaseStudy';
import CSBuildex from 'pages/CaseStudy/CSBuildex';
import CSFocus from 'pages/CaseStudy/CSFocus';
import CSLoha from 'pages/CaseStudy/CSLoha';
import ECommerceGCC from 'pages/ECommerceGCC';
import Schedule from 'pages/Schudule/Schedule';
import Success from 'pages/Schudule/Success';
import type { RouteObject } from 'react-router-dom';

import NotFound from '../../pages/404';
import LandingPage from '../../pages/Landing';
import Portfolio from '../../pages/Portfolio';
import { WebsitesDev, SoftwearDev, MobileDev } from '../../pages/service/Services';
import SingleWork from '../../pages/SingleWork';

export const publicRoutes: RouteObject[] = [
  { path: '/', element: <LandingPage /> },
  { path: '/work/:id', element: <SingleWork /> },

  { path: '/eCommerce/GCC', element: <ECommerceGCC /> },
  { path: '/404', element: <NotFound /> },

  {
    path: '/schedule',
    children: [
      { path: '', element: <Schedule /> },
      { path: 'success', element: <Success /> },
    ],
  },

  {
    path: '/services',
    children: [
      {
        path: 'website',
        element: <WebsitesDev />,
      },
      {
        path: 'softwear',
        element: <SoftwearDev />,
      },
      {
        path: 'mobileapp',
        element: <MobileDev />,
      },
    ],
  },

  {
    path: '/portfolio',
    children: [
      {
        path: '',
        element: <Portfolio />,
      },
      {
        path: 'focus',
        element: <CSFocus />,
      },
      {
        path: 'loha',
        element: <CSLoha />,
      },
      {
        path: 'buildex',
        element: <CSBuildex />,
      },
    ],
  },
];

export const authRoutes: RouteObject[] = [];
